'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// @ts-expect-error TS(7006): Parameter 'cardFields' implicitly has an 'any' typ... Remove this comment to see the full error message
var parseHealthFundCardFields = function parseHealthFundCardFields(cardFields) {
  return (// @ts-expect-error TS(7006): Parameter 'result' implicitly has an 'any' type.
    cardFields.reduce(function (result, field) {
      result[field.id] = field;
      return result;
    }, {})
  );
};

exports["default"] = parseHealthFundCardFields;
